
























import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'NotificationMessage',
  components: {
  },
})
export default class NotificationMessage extends Vue {
  @Prop({ default: 0 })
  private numNotifications!: number;

  private get getFormattedNumber(): number {
    return this.numNotifications > 99 ? 99 : this.numNotifications;
  }
}
